import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if request has skip-loader header
    const skipLoader = req.headers.has('X-Skip-Loader');

    if (skipLoader) {
      // Remove the custom header before sending request
      const clonedReq = req.clone({
        headers: req.headers.delete('X-Skip-Loader'),
      });
      return next.handle(clonedReq);
    }

    // SHOW LOADER for every API call
    this.loaderService.show();

    return next.handle(req).pipe(
      finalize(() => {
        // HIDE loader after every API response
        this.loaderService.hide();
      })
    );
  }
}
